<div class="cm-radio-group">
  <div class="cm-radio-group__label" [id]="labelId">
    @if (required()) {
      <span class="cm-radio-group__required" aria-hidden="true">*</span>
    }
    {{ label() }}
    @if (required()) {
      <span class="cm-radio-group__sr-only"> (required)</span>
    }
  </div>

  <neo-radio-group
    [ngModel]="value"
    (ngModelChange)="onRadioChange($event)"
    [attr.aut-id]="autId()"
    role="radiogroup"
    [attr.aria-labelledby]="labelId"
    [attr.aria-required]="required() ? 'true' : null"
    [attr.aria-invalid]="isErrorVisible() ? 'true' : null"
    [attr.aria-describedby]="isErrorVisible() ? errorId : null"
    class="cm-radio-group__control"
  >
    @for (option of options(); track option.value) {
      <neo-radio-button
        [value]="option.value"
        [disabled]="disabled || option.disabled || false"
        (blur)="onBlur()"
      >
        {{ option.label }}
      </neo-radio-button>
    }
  </neo-radio-group>

  @if (hint()) {
    <div class="cm-radio-group__hint">{{ hint() }}</div>
  }

  <!-- Error messages via reusable component. Wrapped in a stable-id container so
       the radio group can reference it via aria-describedby (WCAG 3.3.1 / 4.1.2). -->
  <div [id]="errorId">
    <cm-field-errors
      [control]="ngControl()?.control || null"
      [label]="label()"
      [customMessages]="errorMessages()"
      [showErrorsWhen]="showErrorsWhen()"
      [hideErrors]="hideErrors()"
      [constraints]="{
        maxlength: null,
        minlength: null,
        min: null,
        max: null
      }"
    />
  </div>

  <!-- Legacy ng-content projection for backward compatibility -->
  <ng-content />
</div>
